module.exports = __webpack_public_path__ + "static/organicrainbow1-5442d2b81a1cdfc194960d04378925ea.png";